export default "__VITE_ASSET__D418x_dS__"